import { render, staticRenderFns } from "./ShiftShow.vue?vue&type=template&id=5fbb2979&scoped=true&"
import script from "./ShiftShow.vue?vue&type=script&lang=js&"
export * from "./ShiftShow.vue?vue&type=script&lang=js&"
import style0 from "./ShiftShow.vue?vue&type=style&index=0&id=5fbb2979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb2979",
  null
  
)

export default component.exports